import type { FC } from 'react';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import { xcss, Box, Inline } from '@atlaskit/primitives';
import Lozenge from '@atlaskit/lozenge';
import { token } from '@atlaskit/tokens';

import { LightningIcon } from './LightningIcon';

const iconStyles = xcss({
	height: '12px',
	width: '12px',
});

const i18n = defineMessages({
	liveEditLozengeText: {
		id: 'live-pages-features.live-edit-lozenge.label',
		defaultMessage: 'Live Edit',
		description:
			'Lozenge indicating the live page feature which allows for real time edit of pages without needing to publish',
	},
});

export type LiveEditLozengeProps = {
	showIcon?: boolean;
};

export const LiveEditLozenge: FC<LiveEditLozengeProps> = ({ showIcon = false }) => (
	<Lozenge
		testId="live-edit-lozenge"
		style={{
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
			backgroundColor: token('color.background.accent.teal.subtler'),
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
			color: token('color.text.accent.teal'),
		}}
	>
		<Inline space="space.050">
			{showIcon && (
				<Box xcss={iconStyles}>
					<LightningIcon label="" />
				</Box>
			)}
			<FormattedMessage {...i18n.liveEditLozengeText} />
		</Inline>
	</Lozenge>
);
